<script setup lang="ts">
import CoreIcon from '@core/core-icon.vue';
import { computed } from 'vue';

const props = defineProps({
	type: {
		type: String,
		default: 'checkbox'
	},
	name: {
		type: String,
		default: null
	},
	value: {
		type: [String, Number],
		default: null
	},
	error: {
		type: Boolean,
		default: false
	},
});
const modelValue = defineModel();
const modes = computed(() => ({
	'form-checkbox_error': props.error
}))
</script>
<template>
	<label class="form-checkbox" :class="modes">
		<input
			:type="type"
			:name="name"
			:value="value"
			v-model="modelValue"
			class="form-checkbox__input"
		>
		<span class="form-checkbox__content">
			<span class="form-checkbox__icon">
				<core-icon
					name="checkbox"
					viewBox="0 0 12 8"
				/>
			</span>
			<span class="form-checkbox__text">
				<slot />
			</span>
		</span>
	</label>
</template>

<style lang="scss">
.form-checkbox {
	display: block;
	cursor: pointer;
	&_error {
		.form-checkbox {
			&__icon {
				box-shadow: inset 0 0 0 2px var(--color-red);
			}
		}
	}
	&__input {
		display: none;
		&:checked {
			& + .form-checkbox__content {
				.form-checkbox {
					&__icon {
						svg {
							opacity: 1;
							transform: scale(1);
						}
					}
				}
			}
		}
	}
	&__content {
		display: flex;
		align-items: center;
		gap: 1rem;
		user-select: none;
	}
	&__text {
		flex: 0 1 auto;
		min-width: 0;
		line-height: 1.2;
	}
	&__icon {
		flex: 0 0 auto;
		width: 2.4rem;
		height: 2.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(var(--color-active-rgb), 0.12);
		fill: rgb(var(--color-icons-rgb));
		border-radius: 0.8rem;
		@include theme-dark {
			box-shadow: inset 1px 1px 1px 0 rgba(255,255,255,0.12);
		}
		svg {
			transition: ease 0.12s;
			opacity: 0;
			transform: scale(0.7);
			width: 1.1rem;
		}
	}
}
</style>
